import axios from "axios";
import API_ENDPOINT from "../wm.api.service";
import Cookies from "universal-cookie";
import { decode } from "base-64";
const cookies = new Cookies();

var token = cookies.get("wmtoken");


export const getCertificateTemplates = async () => {
    let fd = new FormData();
    fd.append("token", decode(token));
    fd.append("identity", "wmhandler");
    fd.append("screenName", "TEMPLATE");
    return await axios({ method: "POST", url: `${API_ENDPOINT.apiURL}Certificate/showClient`, data: fd })
}

export const createEvent = async (eventName, eventDate, templateId, sourceData, numRow, eventSubject, eventContent, prefix) => {
    let fd = new FormData();
    fd.append("token", decode(token))
    fd.append("identity", "wmhandler");
    fd.append("clientId", JSON.parse(decode(token)).id)
    fd.append("eventName", eventName);
    fd.append("templateId", templateId);
    fd.append("sourceData", sourceData);
    fd.append("eventDate", eventDate);
    fd.append("num_rows", numRow);
    fd.append("mail_suject", eventSubject);
    fd.append("mail_content", eventContent);
    fd.append("prefix", prefix);
    return await axios({ method: "POST", url: `${API_ENDPOINT.apiURL}/Certificate/createEvent`, data: fd })
}

export const getEvents = async () => {
    let fd = new FormData();
    fd.append("token", decode(token));
    fd.append("identity", "wmhandler");
    fd.append("screenName", "EVENT");
    return await axios({ method: "POST", url: `${API_ENDPOINT.apiURL}/Certificate/showClient`, data: fd })
}

export const generateCSV = async (templateID) => {
    return await axios.get(`${API_ENDPOINT.apiURL}/Certificate/generateCsv`, {
        params: {
            templateId: templateID,
        }
    })
}

export const getEventData = async ({ eventId, email, page_no }) => {
    let fd = new FormData();
    fd.append("token", decode(token));
    fd.append("identity", "wmhandler");
    fd.append("eventId", eventId)
    fd.append("email", email)
    fd.append("page_no", page_no)
    fd.append("limit", 10)
    return await axios({ method: "POST", url: `${API_ENDPOINT.apiURL}Certificate/getEventData`, data: fd })
}


export const downloadAllPdf = async (eventId) => {
    let fd = new FormData();
    fd.append("token", decode(token));
    fd.append("identity", "wmhandler");
    fd.append("event_id", eventId)
    const res = await axios({ method: "POST", url: `${API_ENDPOINT.apiURL}Certificate/downloadEventAllCertificate`, data: fd, responseType: 'blob' })
    return await res
}


export const getCredits = async () => {
    let fd = new FormData();
    fd.append("token", decode(token));
    fd.append("identity", "wmhandler");
    return await axios({ method: "POST", url: `${API_ENDPOINT.apiURL}profile/getUserCredits`, data: fd })
}

export const uploadUserCSV = async (option, screenName, tabName, sourceData) => {
    let fd = new FormData();
    fd.append("token", decode(token));
    fd.append("identity", "wmhandler");
    fd.append("screen_name", screenName);
    fd.append("tab_name", tabName);
    fd.append("sourceData", sourceData);
    return await axios({
        method: "POST",
        url: `${API_ENDPOINT.apiURL}Certificate/instituteConnections`,
        data: fd,
        onUploadProgress: option.onUploadProgress
    })
}


export const deleteEntityCertificate = async (event_id) => {
    let fd = new FormData();
    fd.append("token", decode(token));
    fd.append("identity", "wmhandler");
    fd.append("event_id", event_id);
    return await axios({ method: "POST", url: `${API_ENDPOINT.apiURL}Certificate/deleteEvent`, data: fd })
}


export const deleteCertificates = async (ids, eventId) => {
    let fd = new FormData();
    fd.append("token", decode(token));
    fd.append("identity", "wmhandler");
    fd.append("cert_id", JSON.stringify(ids));
    fd.append("event_id", eventId);
    return await axios({ method: "POST", url: `${API_ENDPOINT.apiURL}Certificate/deleteCertificate`, data: fd })
}

export const getCertificateDetail = async (cert_id) => {
    let fd = new FormData();
    fd.append("token", decode(token));
    fd.append("identity", "wmhandler");
    fd.append("cert_id", cert_id);
    return await axios({ method: "POST", url: `${API_ENDPOINT.apiURL}Certificate/getCertDetails`, data: fd })
}
